import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array)
{
  for (let i = array.length - 1; i > 0; i--)
  {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function RandomChar()
{
  var result           = '';
  var characters       = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

export default function Rating({ ...props })
{
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  //console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() =>
  {
    if (questions !== undefined)
    {
      let levelQs = [];
      questions.forEach((levelQuestions, i) =>
      {

        var newLevelQuestions = [];
        levelQuestions.forEach(q =>
        {
          console.log(q.right_answer);
          for (var i = 1; i < 12; i++) {
            //All the shared variables
            let questionAnswers = [];
            //Add the correct answer
            questionAnswers.push({ correct: true, value: q.correct});
            //Add the wrong answers
            if(q.wrong_answer1 != "")
            {
            questionAnswers.push({ correct: false, value: q.wrong_answer1});
            }
            if(q.wrong_answer2 != "")
            {
            questionAnswers.push({ correct: false, value: q.wrong_answer2});
            }
            if(q.wrong_answer3 != "")
            {
            questionAnswers.push({ correct: false, value: q.wrong_answer3});
            }

            shuffleArray(questionAnswers);
            console.log(q.question_line_2);
            let questionObj = {
              question: q.question,
              question2: q.question_line2,
              answers: questionAnswers,
              //correct: q.correct,
              topic_id: q.topic_id
            };

            newLevelQuestions.push(questionObj);
          }
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() =>
      {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
    />
  ) : (
      <LoadingScreen />
    );
}
